import React, { FC } from 'react';
import styles from './QuestionTooltip.module.css';
import cls from 'classnames';
import ReactTooltip from 'react-tooltip';

interface QuestionTooltipProps {
  id?: string;
}

const QuestionTooltip: FC<QuestionTooltipProps> = ({ id = 'main', children }) => {
  const questionElement = React.useRef(null);
  const questionContentElement = React.useRef<HTMLDivElement>(null);
  return (
    <div className={styles.QuestionTooltip} data-testid="QuestionTooltip">
      <div
        data-for={id}
        ref={questionElement}
        data-tip={true}
        className={cls('bg-dark text-xl font-bold text-white p-3 ml-2 mt-1', styles.question)}
      >
        <span>?</span>
      </div>
      <ReactTooltip id={id} arrowColor={'transparent'} className={styles.tooltip} effect="solid">
        <div ref={questionContentElement}>{children}</div>
      </ReactTooltip>
    </div>
  );
};

export default QuestionTooltip;
